import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

const SkeletonHeader = (props) => {
  return (
    <SkeletonTheme color="#a4abb3" highlightColor="#e3e6e8">
      <Skeleton {...props} height={props.height ?? "10px"} width={props.width ?? null} />
    </SkeletonTheme>
  );
};

const SkeletonPrimary = (props) => {
  return (
    <SkeletonTheme>
      <Skeleton {...props} height={props.height ?? "10px"} width={props.width ?? null} />
    </SkeletonTheme>
  );
};

const LoadingSkeleton = (props) => {
  return props.variant === "header" ? <SkeletonHeader {...props} /> : <SkeletonPrimary {...props} />;
};

export default LoadingSkeleton;
